import { render, staticRenderFns } from "./ObjectivesSelector.vue?vue&type=template&id=0f8f4e5c&scoped=true"
import script from "./ObjectivesSelector.vue?vue&type=script&lang=js"
export * from "./ObjectivesSelector.vue?vue&type=script&lang=js"
import style0 from "./ObjectivesSelector.vue?vue&type=style&index=0&id=0f8f4e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f4e5c",
  null
  
)

export default component.exports